const bioNeedsApproval = (bio) => (
  bio?.autoSummary?.isAutoSummary === true &&
  bio?.autoSummary?.confidence !== 'high' &&
  bio?.textApproved !== true
);

const approveBio = (bio) => ({ ...bio, textApproved: true });
const updateBioText = (bio, text) => ({ ...bio, text, textApproved: true });

export { bioNeedsApproval, approveBio, updateBioText };
